var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTraditional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 36,
    viewBox: "0 0 375 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-TFA_-_Stacked_Logo_-_Traditional"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 135
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TFA_-_Stacked_Logo_-_Traditional",
    "data-name": "TFA - Stacked Logo - Traditional",
    clipPath: "url(#clip-TFA_-_Stacked_Logo_-_Traditional)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(10391 12809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M99.334,58.567V10.991H82.6V1.148H126.9v9.843H110.162V58.567Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M137.318,13.124a6.64,6.64,0,0,1-4.72-1.806,6.2,6.2,0,0,1-1.926-4.756A6.219,6.219,0,0,1,132.6,1.8a7.13,7.13,0,0,1,9.476,0,6.287,6.287,0,0,1,1.886,4.76,6.272,6.272,0,0,1-1.886,4.756,6.6,6.6,0,0,1-4.756,1.806m-5.17,4.756h10.337V58.567H132.148Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M149.27,58.567V17.88h10.173v4.429h1.476a9.379,9.379,0,0,1,3.528-3.568,12.216,12.216,0,0,1,6.478-1.515,12.761,12.761,0,0,1,6.973,1.682,11.273,11.273,0,0,1,4.022,4.386H183.4a11.972,11.972,0,0,1,3.939-4.346q2.538-1.722,7.216-1.722a14.584,14.584,0,0,1,6.849,1.6,11.96,11.96,0,0,1,4.923,4.839,16.293,16.293,0,0,1,1.846,8.161V58.567H197.831v-26a6.756,6.756,0,0,0-1.722-5.044,6.638,6.638,0,0,0-4.84-1.682,6.79,6.79,0,0,0-5.454,2.256,9.64,9.64,0,0,0-1.929,6.439V58.567H173.552v-26a6.756,6.756,0,0,0-1.722-5.044,6.641,6.641,0,0,0-4.84-1.682,6.792,6.792,0,0,0-5.457,2.256,9.64,9.64,0,0,0-1.926,6.439V58.567Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M233.2,59.716a21.616,21.616,0,0,1-10.7-2.584,18.19,18.19,0,0,1-7.216-7.3A22.791,22.791,0,0,1,212.7,38.718v-.984a23.086,23.086,0,0,1,2.543-11.115,18.015,18.015,0,0,1,7.136-7.3,21.4,21.4,0,0,1,10.665-2.584A19.832,19.832,0,0,1,243.457,19.4a18.339,18.339,0,0,1,6.892,7.383,23.369,23.369,0,0,1,2.46,10.952v3.524H223.2a9.2,9.2,0,0,0,3.117,6.809,10.474,10.474,0,0,0,7.22,2.627q4.346,0,6.4-1.889a13.312,13.312,0,0,0,3.117-4.182l8.448,4.429a26.317,26.317,0,0,1-3.321,4.636,18,18,0,0,1-5.784,4.266,20.959,20.959,0,0,1-9.189,1.762M223.28,33.548h19.028a8.107,8.107,0,0,0-2.827-5.657,11.226,11.226,0,0,0-13.167,0,9.155,9.155,0,0,0-3.034,5.657",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M270.445,58.567V1.148h36.091v9.843H281.273V21.852h15.219V31.7H281.273V58.567Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M320.259,59.715a21,21,0,0,1-10.193-2.459,17.785,17.785,0,0,1-7.13-7.137,22.74,22.74,0,0,1-2.608-11.238V37.57a22.747,22.747,0,0,1,2.608-11.239,17.763,17.763,0,0,1,7.13-7.136,22.329,22.329,0,0,1,20.389,0,17.775,17.775,0,0,1,7.127,7.136A22.747,22.747,0,0,1,340.19,37.57v1.311a22.74,22.74,0,0,1-2.608,11.238,17.8,17.8,0,0,1-7.127,7.137,21.01,21.01,0,0,1-10.2,2.459m0-9.185a9.717,9.717,0,0,0,7.361-3.077q2.91-3.075,2.91-8.819v-.821q0-5.738-2.873-8.818A10.391,10.391,0,0,0,312.9,29q-2.914,3.079-2.913,8.818v.821q0,5.744,2.913,8.819a9.706,9.706,0,0,0,7.358,3.077",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M344.96,58.567V17.88h10.173v4.6h1.476a6.481,6.481,0,0,1,2.994-3.611,9.985,9.985,0,0,1,4.879-1.149h4.924v9.189h-5.087A9.871,9.871,0,0,0,357.84,29q-2.543,2.092-2.543,6.441V58.567Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M82.6,128.6,97.7,71.176h18.868l15.093,57.42H120.5l-2.739-11.113-21.272.061L93.76,128.6Zm16.429-21.088h16.2l-6.635-26.616h-2.928Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M150.035,129.744a17.952,17.952,0,0,1-9.065-2.42,17.659,17.659,0,0,1-6.769-7.1,23.38,23.38,0,0,1-2.544-11.318V107.6A23.388,23.388,0,0,1,134.2,96.276a17.61,17.61,0,0,1,15.834-9.516,19.208,19.208,0,0,1,6.191.862,12.647,12.647,0,0,1,4.062,2.176,10.1,10.1,0,0,1,2.377,2.787h1.479V71.177h10.333V128.6h-10.17v-4.923h-1.479a13.4,13.4,0,0,1-4.305,4.185q-2.914,1.887-8.488,1.886m3.114-9.022a11.027,11.027,0,0,0,7.957-3.077q3.2-3.075,3.2-8.982v-.821q0-5.9-3.157-8.982a11.888,11.888,0,0,0-15.955,0q-3.2,3.08-3.2,8.982v.821q0,5.907,3.2,8.982a11.02,11.02,0,0,0,7.954,3.077",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M190.534,128.6l-12.96-40.687h10.991L198,121.049h1.475l9.432-33.14H219.9L206.939,128.6Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M229.642,83.152a6.638,6.638,0,0,1-4.719-1.805,6.84,6.84,0,0,1,0-9.516,7.128,7.128,0,0,1,9.475,0,6.945,6.945,0,0,1,0,9.516,6.6,6.6,0,0,1-4.756,1.805m-5.17,4.757h10.337V128.6H224.472Z",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M260.772,129.744a23.139,23.139,0,0,1-10.707-2.46,18.529,18.529,0,0,1-7.587-7.136,21.727,21.727,0,0,1-2.791-11.322v-1.148a21.714,21.714,0,0,1,2.791-11.318,18.5,18.5,0,0,1,7.587-7.136,23.1,23.1,0,0,1,10.707-2.463,22.526,22.526,0,0,1,10.007,2.052,17.91,17.91,0,0,1,6.765,5.618,19.583,19.583,0,0,1,3.4,8.08l-10.007,2.133a11.819,11.819,0,0,0-1.475-4.429,8.258,8.258,0,0,0-3.241-3.117,10.725,10.725,0,0,0-5.21-1.149A11.616,11.616,0,0,0,255.4,97.3a9.651,9.651,0,0,0-3.938,4.019,13.6,13.6,0,0,0-1.436,6.522v.821a13.592,13.592,0,0,0,1.436,6.522A9.631,9.631,0,0,0,255.4,119.2a11.607,11.607,0,0,0,5.618,1.356q4.676,0,7.1-2.42a11.4,11.4,0,0,0,3.077-6.359l10.007,2.38a22.507,22.507,0,0,1-3.652,7.914,17.954,17.954,0,0,1-6.765,5.621,22.568,22.568,0,0,1-10.007,2.049",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M304.106,129.744a21.616,21.616,0,0,1-10.7-2.584,18.19,18.19,0,0,1-7.216-7.3,22.78,22.78,0,0,1-2.587-11.115v-.984a23.086,23.086,0,0,1,2.543-11.115,18.015,18.015,0,0,1,7.136-7.3,21.4,21.4,0,0,1,10.665-2.584,19.832,19.832,0,0,1,10.417,2.667,18.34,18.34,0,0,1,6.892,7.383,23.37,23.37,0,0,1,2.46,10.952v3.524H294.1a9.2,9.2,0,0,0,3.117,6.809,10.474,10.474,0,0,0,7.22,2.627q4.346,0,6.4-1.889a13.311,13.311,0,0,0,3.117-4.182l8.448,4.429a26.317,26.317,0,0,1-3.321,4.636,18,18,0,0,1-5.784,4.266,20.959,20.959,0,0,1-9.189,1.762m-9.923-26.168h19.028a8.107,8.107,0,0,0-2.827-5.657,11.226,11.226,0,0,0-13.167,0,9.154,9.154,0,0,0-3.034,5.657",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M333.618,129.744a6.641,6.641,0,0,1-4.72-1.806,6.843,6.843,0,0,1,0-9.516,7.13,7.13,0,0,1,9.476,0,6.945,6.945,0,0,1,0,9.516,6.6,6.6,0,0,1-4.756,1.806",
    transform: "translate(-10388 -12806)",
    fill: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M59.772,1.148H12.857A12.857,12.857,0,0,0,0,14.005V60.92A12.857,12.857,0,0,0,12.857,73.777,3.043,3.043,0,0,1,15.9,76.819v7.113a2.689,2.689,0,0,0,4.166,2.247l14.025-9.226A19.3,19.3,0,0,1,44.7,73.777H59.772A12.858,12.858,0,0,0,72.629,60.92V14.005A12.857,12.857,0,0,0,59.772,1.148M63.55,59.467A5.231,5.231,0,0,1,58.319,64.7H14.309a5.231,5.231,0,0,1-5.231-5.231V15.457a5.231,5.231,0,0,1,5.231-5.231h44.01a5.231,5.231,0,0,1,5.231,5.231Z",
    transform: "translate(-10388 -12806)",
    fill: "#2f68fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M50.446,35.568H41.775A5.894,5.894,0,0,0,38.613,32.4V17.7a2.3,2.3,0,0,0-4.6,0V32.4a5.938,5.938,0,0,0-3.631,5.462,5.84,5.84,0,0,0,.42,2.181l-6.869,6.735a2.3,2.3,0,0,0,3.218,3.282l6.869-6.733a5.863,5.863,0,0,0,2.291.464,5.936,5.936,0,0,0,5.461-3.631h8.671a2.3,2.3,0,1,0,0-4.6",
    transform: "translate(-10388 -12806)",
    fill: "#2f68fa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTraditional);
export default __webpack_public_path__ + "static/media/logo_traditional.13023827a7a3bc2fc900282a68238428.svg";
export { ForwardRef as ReactComponent };